import Cropper from "cropperjs"
import {Modal} from "bootstrap"

const imageInputContainer = document.getElementsByClassName('image-input-container')

if (imageInputContainer.length > 0) {
    const cropBtn = document.getElementById('crop-btn')
    const modalElement = document.getElementById('crop-image-modal')
    const imageContainer = document.getElementById('image-container')
    const modal = new Modal(modalElement)

    Array.from(imageInputContainer).forEach(container => {
        const imageFileInput = container.getElementsByClassName('image-file')[0]
        const deleteImageRow = container.getElementsByClassName('delete-image-row')[0]
        const deleteImageCheckbox = container.getElementsByClassName('delete-image')[0]
        const imageRow = container.getElementsByClassName('image-row')[0]
        const imageColumn = container.getElementsByClassName('image-column')[0]
        const imagePreview = container.getElementsByClassName('image-preview')[0]

        deleteImageCheckbox.addEventListener('change', function () {
            if (this.checked) {
                imageFileInput.disabled = true
                imageRow.classList.add('hidden')
            } else {
                imageFileInput.disabled = false
                imageRow.classList.remove('hidden')
            }
        })

        imageFileInput.addEventListener('change', () => {
            const imgData = imageFileInput.files[0]
            const url = URL.createObjectURL(imgData)
            let isImageCropped = false
            imageContainer.innerHTML = `<img src="${url}" id="cropper-img" style="width: 100%;">`

            modal.show()
            const image = document.getElementById('cropper-img')

            const cropper = new Cropper(
                image,
                {
                    aspectRatio: 1,
                    autoCropArea: 1,
                    viewMode: 1,
                    scalable: false,
                    zoomable: false,
                    movable: false,
                    minContainerWidth: 400,
                    minContainerHeight: 400
                }
            )
            modalElement.addEventListener('hidden.bs.modal', () => {
                if (!isImageCropped) {
                    imageFileInput.files = new DataTransfer().files
                }
            })

            cropBtn.addEventListener('click', () => {
                isImageCropped = true
                const croppedCanvas = cropper.getCroppedCanvas()
                imageColumn.classList.remove('hidden')
                croppedCanvas.toBlob((blob) => {
                    let file = new File([blob], imgData.name, {type: imgData.type, lastModified: new Date().getTime()})
                    let container = new DataTransfer()
                    container.items.add(file)
                    imageFileInput.files = container.files
                })
                imagePreview.src = croppedCanvas.toDataURL()
                deleteImageRow.classList.remove('hidden')
                modal.hide()
            })
        })
    })
}
